export default "__VITE_ASSET__XEXz9Reo__"